import { render, staticRenderFns } from "./MetricsTab.vue?vue&type=template&id=3f0f3384&scoped=true&"
import script from "./MetricsTab.vue?vue&type=script&lang=js&"
export * from "./MetricsTab.vue?vue&type=script&lang=js&"
import style0 from "./MetricsTab.vue?vue&type=style&index=0&id=3f0f3384&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0f3384",
  null
  
)

export default component.exports